const ratio = document.documentElement.clientWidth / 430

document.documentElement.style.fontSize = ratio + 'px'

window.addEventListener('resize', () => {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 430 + 'px'
})

export function rem2px(rem){
    return rem * ratio
}